<template>
    <v-container fluid class="pa-0">
        <!-- Map -->
        <l-map ref="mapRef" :zoom="zoom" :center="center" style="height: calc(100vh - 50px); width: 100%;">
            <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; OpenStreetMap contributors"></l-tile-layer>
            <template>
                <l-marker v-for="item in filteredShops" :key="item.id"
                    :lat-lng="[item.position?.latitude, item.position?.longitude]" ref="markerRefs">
                    <l-icon :icon-anchor="staticAnchor" :icon-size="['40', '40']" class-name="someExtraClass"
                        :icon-url="`/images/mapicons/map-icon-${item.productCategories?.[0]?.identifier ?? 'home'}.png`">
                    </l-icon>
                    <l-popup>
                        <v-list-item width="200px" class="pa-0">
                            <v-row align="center">
                                <v-col md="12" lg="2" align="center">
                                    <v-avatar tile :image="`${$cloudFrontApi}${item.avatar}/AVATAR`"
                                        size="30"></v-avatar>
                                </v-col>
                                <v-col md="12" lg="10">
                                    <v-list-item-title>{{ item?.name }}</v-list-item-title>
                                    <v-list-item-subtitle :style="{
                                        color: item.openingStatus.nextOpeningTime == null && item.openingStatus.nextClosingTime != null
                                            ? '#0c850c'
                                            : item.openingStatus.nextOpeningTime != null && item.openingStatus.nextClosingTime == null
                                                ? '#bb1824'
                                                : '#bb1824'
                                    }">
                                        {{ item?.openingStatus.nextOpeningTime == null &&
                                            item?.openingStatus.nextClosingTime != null ? 'geöffnet' : 'geschlossen' }}
                                    </v-list-item-subtitle>
                                </v-col>
                            </v-row>
                        </v-list-item>
                    </l-popup>
                </l-marker>
            </template>
            <v-container class="text-center position-absolute bottom-50"
                v-if="['sm', 'xs'].includes($globalState.screenWidth)">
                <v-icon @click.stop="scrollTo(sheetRef, 'bottom')" size="64" color="grey" style="z-index:800;"
                    :icon="'mdi-chevron-double-down'"></v-icon>
            </v-container>
        </l-map>

        <transition name="width-transition">
            <v-sheet ref="sheetRef" class="sidebar-overlay" :style="sheetStyle" elevation="5" rounded="0">
                <h3 class="mt-3"> {{ $t('shop.search.label', { searchWord: route.params.value }) }}</h3>
                <v-row class="mx-0 mt-1">
                    <v-btn-toggle mandatory v-model="filter" selected-class="product-filter-selected"
                        v-if="shops.length >= 1">
                        <v-btn :ripple="false" variant="text" value="shops">{{ $t('shop.search.shops') }}</v-btn>
                        <v-btn :ripple="false" variant="text" value="products">{{ $t('shop.search.products') }} </v-btn>
                    </v-btn-toggle>
                </v-row>
                <v-list v-if="filter == 'shops'" active-class="shop-active" bg-color="transparent" class="map-shop-list"
                    @update:selected="shopSelected">
                    <template v-if="shops.length >= 1">
                        <v-list-item class="map-search-entry mb-3 bg-white py-2" :value="item" :ripple="false"
                            v-for="(item, index) in shops" :key="index">
                            <v-row align="center">
                                <v-col cols="4" md="4" lg="2" align="center">
                                    <v-avatar tile :image="`${$cloudFrontApi}${item.avatar}/AVATAR`"
                                        size="64"></v-avatar>
                                </v-col>
                                <v-col cols="8" md="8" lg="10">
                                    <v-list-item-title @click.stop="$router.push({ path: `/${selectedArea.urlName}/laden/${item.urlname}`, query: { mode: 'all', lang: selectedLanguage.toUpperCase() } })">{{ item?.name }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ item?.tagline }}</v-list-item-subtitle>
                                    <div class="shop-opening">
                                        <span
                                            :class="{ 'shop-opened': item.openingStatus.nextOpeningTime == null && item.openingStatus.nextClosingTime != null, 'shop-closed': item.openingStatus.nextOpeningTime != null && item.openingStatus.nextClosingTime == null }">{{
                                                $formatOpeningStatus(item?.openingStatus) }}</span>
                                        <!-- <span>{{$formatOpeningStatus(item?.openingStatus)}} geschlossen</span> -->
                                        <span v-if="item?.openingStatus.from && item?.openingStatus.to">{{
                                            item?.openingStatus.from }}
                                            - {{ item?.openingStatus.to }}</span>
                                        <span v-else>{{ $t('global.openning-hours.empty') }}</span>
                                    </div>
                                    <v-avatar icon="mdi-cart" color="blue" size="30"></v-avatar>
                                </v-col>
                            </v-row>
                        </v-list-item>
                    </template>
                    <p v-else v-html="$t('shop.search.noResults')">
                    </p>
                </v-list>
                <v-container v-else class="position-relative">
                    <template v-if="products.length >= 1">
                        <MasonryGrid :items="products" :max-columns="4" :min-columns="1" :customClass="'mt-8 pa-0'">
                            <template v-slot="{ item, index }">
                                <!-- Custom content for each item -->
                                <CustomNewsCard :item="item" :img="item.image" :title="index" :openPostPopup="openPost">
                                </CustomNewsCard>
                            </template>
                        </MasonryGrid>
                        <v-row justify="center" class="mt-3">
                            <template v-if="loading">
                                <v-progress-circular color="primary"
                                    indeterminate></v-progress-circular>{{ $t('global.common.loading.more') }}
                            </template>
                            <template v-else>
                                <div>
                                    {{ $t('global.common.loading.endOfStream') }}!
                                </div>
                            </template>
                        </v-row>
                        <div style="position: absolute;bottom: 40px;left: 50%;height: 40px;width: 40px;"
                            v-intersect="infiniteProductScrolling">
                        </div>
                    </template>
                    <h3 v-else>
                        Leider keine Produkte vorhanden.
                    </h3>
                </v-container>
                <v-container class="text-center sticky-bottom position-absolute bottom-0"
                    v-if="['sm', 'xs'].includes($globalState.screenWidth) && atBottom">
                    <v-icon @click.stop="scrollTo(sheetRef, 'top')" size="64" color="grey" style="z-index:800;"
                        :icon="'mdi-chevron-double-up'"></v-icon>
                </v-container>
            </v-sheet>
        </transition>

    </v-container>
</template>

<script>
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from "@vue-leaflet/vue-leaflet";
import L from "leaflet";
// import CustomMasonryGrid from "../custom/CustomMasonryGrid.vue";
import CustomNewsCard from "../custom/CustomNewsCard.vue";
import { onMounted, ref, inject, getCurrentInstance, watch, computed, nextTick, onUnmounted } from 'vue';
import { useRoute } from 'vue-router'
import MasonryGrid from "../custom/MasonryGrid.vue";

export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        MasonryGrid,
        CustomNewsCard,
        LIcon
    },

    setup(props) {
        const route = useRoute();
        const productCategories = inject('productCategories')
        const selectedArea = inject("selectedArea");
        const { proxy } = getCurrentInstance();
        const products = ref([]);
        const shops = ref([]);
        const hardToken = localStorage.getItem("hardToken");
        const softToken = localStorage.getItem("softToken");
        const username = localStorage.getItem("username");
        const productCategory = ref(null);
        const center = ref([selectedArea.value.location.latitude, selectedArea.value.location.longitude])
        const zoom = ref(12);
        const selectedShop = ref(null)
        const markerRefs = ref([]);
        const selectedLanguage = localStorage.getItem('selectedLanguage');

        const selectedType = computed(() => ({
            produktgruppe: 'PRODUCT_GROUP',
            marke: 'BRAND',
            viertel: "DISTRICT",
            laden: "SHOP_NAME"
        }[route.params.type] || null)); // Returns `null` if type is not found



        const selectedCategory = computed(() => {
            return productCategories.value.find(a => a.name === route.params.value) || null;
        });

        const filteredShops = computed(() => {
            return shops.value.filter(item => item.position);
        });

        const shopSelected = async (event) => {
            if (event.length == 0) {
                zoom.value = 12;
                center.value = [selectedArea.value.location.latitude, selectedArea.value.location.longitude];
                selectedShop.value = null;
                return;
            } else {
                const shop = event[0];
                zoom.value = 20;
                selectedShop.value = shop;
                center.value = [shop.position.latitude, shop.position.longitude];

                await nextTick();

                const marker = markerRefs.value.find(
                    (m) => m?.leafletObject && m.$.vnode.key === shop.id
                );

                if (marker?.leafletObject) {
                    marker.leafletObject.openPopup(); // Opens the popup programmatically
                } else {
                    console.warn("Marker not found for shop:", shop);
                }
            }
        }





        const customIcon = L.icon({
            iconUrl: "/images/mapicons/map-icon-baby.png",
            iconSize: [40, 40],
            iconAnchor: [20, 40],
            popupAnchor: [0, -40]
        });

        // Watch for changes in route.params.value or productCategories
        const loading = ref(false)
        const page = ref(0)
        const totalPages = ref(null)
        const infiniteProductScrolling = async (entries, observer, isIntersecting) => {
            if (isIntersecting && loading.value == false) {
                loading.value = true;
                setTimeout(async () => {

                    if (page.value < totalPages.value) {
                        page.value++;
                        const filter = {
                            page: page.value,
                            resultsPerPage: 8,
                            streamFilter: {
                                categories: ['product'],
                                cities: [selectedArea.value.identifier],
                                // productCategoryIds: [productCategory.value?.id]
                                ...(route.params.type === 'kategorie'
                                    ? { productCategoryIds: [productCategory.value.id] }
                                    : route.params.type === 'viertel' ? { districts: [route.params.value] } : { shopIds: shops.value.map(({ id }) => id) }
                                )
                            }
                        };
                        try {
                            const response = await proxy.$axios.post('/stream/public/v2/filtered',
                                filter,
                                {
                                    headers: {
                                        'X-Auth-HARDTOKEN': hardToken,
                                        'X-Auth-SOFTTOKEN': softToken,
                                        'X-Auth-USER': username
                                    },
                                },
                            );
                            if (response.status == 200 && response.data.data.length > 1) {
                                products.value = [...products.value, ...response.data.data]


                                // loading.value = false;
                            }
                            loading.value = false;
                        } catch (error) {
                            console.error("Error: ", error);
                            loading.value = false;
                        }
                    }
                    loading.value = false;
                }, 500)
            }
        }

        watch(() => products.value, (newVal) => {

            console.log(`PRODUCTS CHANGED:${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}:${new Date().getMilliseconds()}`, newVal);

        }, { deep: true });

        watch(() => loading.value, (newVal) => {

            console.log(`LOADING CHANGED:${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}:${new Date().getMilliseconds()}`, newVal);

        }, { deep: true });


        const fetchProducts = async () => {
            const filter = {
                page: page.value,
                resultsPerPage: 8,
                streamFilter: {
                    categories: ['product'],
                    cities: [selectedArea.value.identifier],
                    // productCategoryIds: [productCategory.value?.id]
                    ...(route.params.type === 'kategorie'
                        ? { productCategoryIds: [productCategory.value.id] }
                        : route.params.type === 'viertel' ? { districts: [route.params.value] } : { shopIds: shops.value.map(({ id }) => id) }
                    )
                }
            };
            try {
                const response = await proxy.$axios.post('/stream/public/v2/filtered',
                    filter,
                    {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    },
                );
                if (response.data.status == "OK") {
                    products.value = response.data.data
                    totalPages.value = response.data.totalPages
                }
            } catch (error) {
                console.error("Error: ", error);
            }
        }


        const fetchShops = async (from) => {
            const filter = {
                area: selectedArea.value.urlName === route.params.city ? selectedArea.value.identifier : null,
                lang: selectedLanguage.toUpperCase(),
                location: selectedArea.value.location,
                page: 0,
                resultsPerPage: 500,
                ...(route.params.type === 'kategorie'
                    ? { frontendId: productCategory.value.frontendId, name: route.params.value }
                    : { searchWords: [{ type: selectedType?.value, value: route.params.value }] }
                )
            };
            if (filter.area == null) return;
            const url = route.params.type === 'kategorie' ? "search/productcategory" : "/search/freetext"
            try {
                const response = await proxy.$axios.post(url,
                    filter,
                    {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    },
                );
                if (response.data.status == "OK") {
                    shops.value = response.data.data
                }
            } catch (error) {
                console.error("Error: ", error);
            } finally {
                center.value = [selectedArea.value.location.latitude, selectedArea.value.location.longitude];
                fetchProducts();
            }
        }

        const sheetRef = ref(null);
        const mapRef = ref(null);

        const scrollTo = (view, direction) => {
            if (!view) return; // Prevent errors if ref is not yet assigned
            console.log(view)

            const element = view.$el || view; // Handle Vue components & raw DOM elements

            const position = element.getBoundingClientRect().top + window.scrollY;

            switch (direction) {
                case 'top':
                    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll the whole page
                    break;

                case 'bottom':
                    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' }); // Scroll the whole page
                    break;

                default:
                    window.scrollTo({ top: position, behavior: 'smooth' }); // Scroll the whole page
                    break;
            }


        };


        watch([() => route.params.value, productCategories], () => {
            productCategory.value = selectedCategory.value;

            if (route.params.type === 'kategorie' && productCategory.value) {
                fetchShops("WATCH route.params.value for KATEGORIE");
                // fetchProducts();
            } else if (route.params.type !== 'kategorie') {
                fetchShops("WATCH route.params.value for non KATEGORIE");
            }
            // center.value = [selectedArea.value.location.latitude, selectedArea.value.location.longitude];
        }, { deep: true, immediate: true });



        watch(() => selectedArea.value, (newVal) => {

            fetchShops("WATCH selectedArea.value");
        }, { deep: true });
        const atBottom = ref(false);

        const checkScroll = () => {
            atBottom.value = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 10;
        };

        onMounted(() => {
            if (['md', 'lg', 'xl'].includes(proxy.$globalState.screenWidth)) {
                document.documentElement.classList.add("no-scroll");
            } else {
                window.addEventListener("scroll", checkScroll);
            }
            // TODO TIMING ISSUE
            if (route.params.type != 'kategorie' && selectedArea.value != null) {
                // fetchShops();
            }
        });

        onUnmounted(() => {
            document.documentElement.classList.remove("no-scroll");
            window.removeEventListener("scroll", checkScroll);
        });

        return {
            productCategories,
            products,
            shops,
            center,
            zoom,
            selectedShop,
            shopSelected,
            markerRefs,
            loading,
            infiniteProductScrolling,
            page,
            route,
            filteredShops,
            scrollTo,
            sheetRef,
            atBottom,
            mapRef,
            selectedArea,
            selectedLanguage
        }
    },

    watch: {
        filter(newValue) {
            // Adjust width based on filter value
            this.sidebarWidth = newValue === "products" ? "100%" : "33%";
        },
    },

    computed: {
        sheetStyle() {
            let width = '33%';  // Default width
            let scroll = 'hidden'
            let position = 'absolute'
            let padding = '50px 20px 64px 20px'
            if (this.filter === 'products') {
                width = '100%';  // When Option 2 is selected
                scroll = 'scroll'
            }
            if (['xs', 'sm'].includes(this.$globalState.screenWidth)) {
                width = '100%';
                position = 'relative'
                padding = '20px 20px 64px 20px'
            }
            return {
                width: width,
                transition: 'width .7s ease',  // Add transition for width change
                'overflow-y': scroll,
                position: position,
                padding: padding,
                'overflow-x': 'hidden'
            };
        },
        openingStatusColor() {
            let color = '#bb1824';
            if (this.item?.openingStatus?.nextOpeningTime == null) {
                color = '#0c850c';
            }
            return {
                color: color,
                transition: 'width .7s ease',  // Add transition for width change
                'overflow-y': scroll,
            };
        },
    },

    data() {
        return {
            filter: 'shops',
            selectedTown: null,
            // zoom: 12,
            // center: [51.505, -0.09], // Default center
            sidebarWidth: "33%",

        };
    },
    methods: {
        centerMap(shop) {
            this.center = [shop.latitude, shop.longitude];
        },
    },
};
</script>

<style>
/* Ensure Leaflet map tiles are visible */
.leaflet-container {
    z-index: 1;
}

.map-shop-list .v-list-item--active>.v-list-item__overlay,
.map-shop-list .v-list-item:hover .v-list-item__overlay {
    opacity: 0 !important;
}

.map-search-entry .shop-opening .shop-opened {
    color: #0c850c;
}

.map-search-entry .shop-opening .shop-closed {
    color: #bb1824;
}
</style>
<style scoped>
/* Ensure Leaflet map tiles are visible */
.width-transition-enter-active,
.width-transition-leave-active {
    transition: width 0.5s ease;
}



.sidebar-overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    padding: 50px 20px 64px 20px;
    background-color: rgba(255, 255, 255, 0.8);
    /* Semi-transparent background */
    z-index: 10;
    /* Ensure it stays above the map */
}

.map-search-entry .shop-opening {
    display: flex;
    font-size: 14px;
    justify-content: space-between;
}

.bottom-50 {
    bottom: 50px !important;
}

.shop-active {
    border: 1px solid #34a4bf;
}

.map-shop-list {
    overflow-y: scroll;
    height: 83vh;
}
</style>